import { HttpClient } from '@/shared/infra/http/HttpClient';
import { PendingEverifyItem } from '@/features/pending_everify/application/domain/entities/PendingEverifyItem';
import { PendingEverifyItemDto } from '@/features/pending_everify/infra/repositories/dto/PendingEverifyItemDto';
import { mapPendingEverifyItemDtoToEntity } from '@/features/pending_everify/infra/repositories/mappers/pendingEverifyItemMapper';
import { IEVerifyCaseSummaryRepository } from '../../application/ports/outbound/IEVerifyCaseSummaryRepository';

export class ApiEVerifyCaseSummaryRepository implements IEVerifyCaseSummaryRepository {
  constructor(private readonly httpClient: HttpClient) {}

  /**
   * GET /e-verify/case-summary?i9FormId={i9FormId}&page=1&pageSize=100
   *
   * Pagination is handled internally — page=1 and pageSize=100 are
   * always sent statically. No UI pagination is exposed.
   */
  async fetchEVerifyCaseSummary(i9FormId: string): Promise<PendingEverifyItem[]> {
    const response = await this.httpClient.getPaginated<PendingEverifyItemDto>(
      `/e-verify/case-summary?i9FormId=${i9FormId}&page=1&pageSize=100`
    );

    const items: PendingEverifyItemDto[] = response.data ?? [];
    return items.map(mapPendingEverifyItemDtoToEntity);
  }
}
